/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import { CLEAR_KEY_EVENT, ON_KEY_EVENT, ON_MOUSE_EVENT } from './inputfactory.types';

/**
 * Creates a Redux action for keyboard events.
 *
 * @internal This action creator must only be used by KeyboardEvent.tsx or MouseEvent.tsx
 * @param key - The key value (e.g., 'Enter', 'Space', 'ArrowUp')
 * @param code - The numeric key code
 * @returns Redux action with key event payload
 */
export const onKeyEventAction = (
    key: string,
    code: number,
): TivoPayloadAction<{ key: string; code: number }> => ({
    type: ON_KEY_EVENT,
    payload: {
        key,
        code,
    },
});

/**
 * Creates a Redux action for mouse events.
 *
 * @internal This action creator must only be used by MouseEvent.tsx or KeyboardEvent.tsx
 * @param eventType - The type of mouse event (e.g., 'click', 'move', 'down', 'up')
 * @param value - The event data or value associated with the mouse event
 * @returns Redux action with mouse event payload
 */
export const onMouseEventAction = (
    eventType: string,
    value: any,
): TivoPayloadAction<{ eventType: string; value: any }> => ({
    type: ON_MOUSE_EVENT,
    payload: {
        eventType,
        value,
    },
});

/**
 * Creates a Redux action to clear/reset the current key event state.
 *
 * @internal This action creator must only be used by KeyboardEvent.tsx or MouseEvent.tsx
 * @returns Redux action that clears key event payload to empty state
 */
export const clearKeyEventAction = (): TivoPayloadAction<{}> => ({
    type: CLEAR_KEY_EVENT,
    payload: {
        key: '',
        code: 0,
    },
});
